// angular
// 	.module("HeroPRO")
// 	.controller("AddBankInfoController", addBankInfoController);

/* @ngInject */
export default function addBankInfoController($rootScope) {
    const vm = this;

    vm.notifications = [];

    vm.financeInfo = {};


    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.cancelAdd = function () {
        $rootScope.$broadcast('closeNotificationModal', { result: false, errorStatus: null });
    };

    vm.add = function () {

    };

    /* -----  End of Public Functions  ------*/

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */

    function init() {

    }


    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/addBankInfo/addBankInfoController.js